"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FContainer = void 0;
const react_1 = __importDefault(require("react"));
const FContainer = ({ width, type = "", children = undefined, }) => {
    return (react_1.default.createElement("div", { className: `f-container ${type}`, style: { maxWidth: `${width}px` } }, children));
};
exports.FContainer = FContainer;
//# sourceMappingURL=Fcontainer.js.map